import React from 'react';

import classNames from 'classnames';

import { ContactsCardContactRole, type Props as ContactRoleProps } from './contact_role';
import type { EmploymentGroup } from './helpers';

interface Props extends Omit<ContactRoleProps, 'contactRole'> {
  group: EmploymentGroup;
  index: number;
}

export function ContactsCardEmploymentGroup({ group, index: outerIndex, ...props }: Props) {
  return <>
    {group.contactRoles.map((contactRole, innerIndex) => (
      <ContactsCardContactRole
        {...props}
        className={classNames({ 'border-top': innerIndex === 0 && outerIndex > 0 })}
        contactRole={contactRole}
        hasSiblingAbove={innerIndex > 0}
        hasSiblingBelow={!!group.employerRole}
        key={`${contactRole.contact.id}-${contactRole.role}`}
      />
    ))}

    {group.employerRole &&
      <ContactsCardContactRole
        {...props}
        contactRole={group.employerRole}
        hasSiblingAbove
        showRoleLabel={false}
      />
    }
  </>;
}
